import PropTypes from 'prop-types';

export const HAMBURGER_TOGGLE_ID = 'mobile-nav-menu-toggle';
export const MOBILE_NAV_MENU_ID = 'mobile-nav-menu';
export const MOBILE_NAV_CONTENT_MENU_BACK_BUTTON_ID =
  'mobile-nav-content-menu-back';

export const tabInfoPropType = PropTypes.shape({
  urlName: PropTypes.string.isRequired,
  hasDropdown: PropTypes.bool.isRequired,
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      items: PropTypes.arrayOf(
        PropTypes.shape({
          column: PropTypes.number.isRequired,
          title: PropTypes.string.isRequired,
          type: PropTypes.string.isRequired,
          url: PropTypes.string.isRequired,
          icon: PropTypes.string,
        })
      ),
    })
  ),
  seeAll: PropTypes.shape({
    column: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    icon: PropTypes.string,
  }),
  gradesForContentType: PropTypes.arrayOf(
    PropTypes.shape({
      longDisplay: PropTypes.string.isRequired,
      urlName: PropTypes.string.isRequired,
    })
  ),
  seasonalInfo: PropTypes.shape({
    startDate: PropTypes.string.isRequired,
    endDate: PropTypes.string.isRequired,
    icon: PropTypes.string,
  }),
});

export default tabInfoPropType;

export const isSeasonalNavButtonActive = seasonalInfo => {
  try {
    const { startDate, endDate } = seasonalInfo;
    const today = new Date().toISOString().split('T')[0]; // in YYYY-MM-DD
    return startDate <= today && today <= endDate;
  } catch (e) {
    // Not fatal
  }
  return false;
};

// Easy and quick way to check if an element is visible in the DOM, without having to check every parent's style, etc.
export const isElementVisible = element => !!element.offsetParent;
